import { difference, get } from "lodash-es";
import { MAXIMUM_BUILD_SIZE } from "./constant";

export class OnmoStorage {
  static getHtmlKeys = () => {
    return localStorage.getItem("htmlgame:keys");
  };

  static setHtmlKeys = (keys: string) => {
    localStorage.setItem("htmlgame:keys", keys);
  };
}

export const loadGame = (
  xhr: XMLHttpRequest,
  script: HTMLScriptElement,
  pathGameData: string,
  setLoadedPercentage?: (percent: number) => void,
) => {
  return new Promise((resolve, reject) => {
    script.src = pathGameData;
    document.body.appendChild(script);
    script.id = pathGameData;
    script.addEventListener("load", () => {
      resolve(script);
    });
    script.addEventListener("error", (e) => {
      reject(e);
    });

    xhr.open("GET", pathGameData, true);
    xhr.onload = () => {
      if (xhr.readyState === 4) {
        script.text = xhr.response;
        document.body.appendChild(script);
        resolve(script);
      }
    };
    xhr.onprogress = function (e) {
      const progress = Math.round((e.loaded / MAXIMUM_BUILD_SIZE) * 100);
      setLoadedPercentage?.(Math.min(progress + 10, 100));
    };

    xhr.send();
  });
};

export const removeScript = (script: Node) => {
  script?.parentNode?.removeChild(script);
  const canvas =
    document.getElementById("UT_CANVAS") ||
    document.getElementById("game-phaser") ||
    document.getElementById("phaser-game");
  canvas?.parentNode?.removeChild(canvas);

  // Fix issue can not replay unity game because canvasElement reference is not cleared
  const utCanvas = get(window, "ut._HTML");
  if (utCanvas) {
    utCanvas.canvasElement = undefined;
  }
};

export const resetStyleBody = (oldBody: { [key: string]: string }) => {
  if (document.body) {
    ["margin", "border", "overflow", "display"].forEach((property: string) => {
      if (oldBody[property]) {
        document.body.style.setProperty(property, oldBody[property]);
      } else {
        document.body.style.removeProperty(property);
      }
    });
  }
};

export const freeMemoryAfterPlaying = (keysBefore: string[]) => {
  // Sadly nothing to do here since the window is populated by hundreds of unknown variables
  // from the HTML games when loaded

  if (!keysBefore) return;

  const windowAny = window as any;
  const keysAfter = Object.keys(window);
  const diffKeys = difference(keysAfter, keysBefore);
  diffKeys.forEach((key: string) => {
    try {
      if (
        [
          "orientation",
          "Window",
          "helpshiftConfig",
          "Helpshift",
          "OnmoHtmlGame",
        ].includes(key)
      )
        return;
      const value = windowAny[key];
      const typeofValue = typeof value;
      windowAny[key] = null;
      switch (typeofValue) {
        case "function":
          windowAny[key] = () => {
            /* do nothing */
          };
          break;
        case "object":
          windowAny[key] = { _HTML: { input: {} } };
          break;
        case "string":
          windowAny[key] = "";
          break;
        default:
          break;
      }
    } catch (e) {
      // console.log(`Fail to clean key ${key}`, e);
    }
  });
  console.info(`${diffKeys.length} keys cleaned.`);
};

export const convertSeeds = (seed?: string | number) => {
  if (typeof seed === "number") {
    return seed;
  } else if (!seed || seed === "N/A") {
    return new Date().getTime();
  } else {
    const hash = (s: string) => {
      let h = 9;
      for (let i = 0; i < s.length; ) {
        h = Math.imul(h ^ s.charCodeAt(i++), 9 ** 9);
      }
      return h ^ (h >>> 9);
    };
    return hash(seed);
  }
};
